import React, { useState } from "react";
import LoadingSpinner from "@proxy/_components/LoadingSpinner"
import OverlayMiddleError from "../_components/OverlayMiddleError";
import OverlayMiddleThumbnail from "../_components/OverlayMiddleThumbnail";
import OverlayMiddlePlayback from "../_components/OverlayMiddlePlayback";
import OverlayMiddleRecord from "../_components/OverlayMiddleRecord";

export default function OverlayMiddle({
  loading,
  overlayState,
  setOverlayState,
  isRecording,
  startCamera,
  closeModal,
  media,
  videoDuration,
  updateFormField,
  formData,
  playRecording,
  setHasThumbnail
}) {
  const overlayMarkup = ( loading ) ?
    <div className="gc__camera_loading">
      <LoadingSpinner/>
    </div> :
  ( overlayState === "error" ) ?
    <OverlayMiddleError /> :
  ( overlayState === "thumbnail" ) ?
    <OverlayMiddleThumbnail
      media={media}
      videoDuration={videoDuration}
      updateFormField={updateFormField}
      formData={formData}
      setHasThumbnail={setHasThumbnail}
    /> :
  ( overlayState === "playback-complete" || overlayState === "playback-inProgress" ) ?
    <OverlayMiddlePlayback
      overlayState={overlayState}
      setOverlayState={setOverlayState}
      startCamera={startCamera}
      playRecording={playRecording}
      media={media}
      videoDuration={videoDuration}
    /> :
  ( overlayState === "ready" ) ?
    <OverlayMiddleRecord /> :
    <></>

  return (
    <>
      {overlayMarkup}
    </>
  );
}
